import { render } from "./NoPermission.vue?vue&type=template&id=7ea81d4e&scoped=true"
const script = {}

import "./NoPermission.vue?vue&type=style&index=0&id=7ea81d4e&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/bj-International-card-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea81d4e"]])

export default __exports__